<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width="200"
    height="200"
    viewBox="0 0 200 200"
    xml:space="preserve"
  >
    <g
      transform="matrix(2.48 0 0 2.48 100 100)"
      id="89f50520-1824-4f7a-9a68-2c8c1aca623e"
    >
      <rect
        :fill="outercol"
        style="
          stroke: #111827;
          stroke-width: 2;
          stroke-dasharray: none;
          stroke-linecap: butt;
          stroke-dashoffset: 0;
          stroke-linejoin: miter;
          stroke-miterlimit: 4;
          fill-rule: nonzero;
          opacity: 1;
        "
        vector-effect="non-scaling-stroke"
        x="-33.085"
        y="-33.085"
        rx="0"
        ry="0"
        width="66.17"
        height="66.17"
      />
    </g>
    <g
      transform="matrix(1.5 0 0 1.5 100 100)"
      id="eba2d251-2f15-444e-988e-5a802de568eb"
    >
      <rect
        :fill="insidecol"
        style="
          stroke: #111827;
          stroke-width: 2;
          stroke-dasharray: none;
          stroke-linecap: butt;
          stroke-dashoffset: 0;
          stroke-linejoin: miter;
          stroke-miterlimit: 4;
          fill-rule: nonzero;
          opacity: 1;
        "
        vector-effect="non-scaling-stroke"
        x="-33.0835"
        y="-33.0835"
        rx="0"
        ry="0"
        width="66.167"
        height="66.167"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    outercol: {
      type: String,
      default: "",
    },
    insidecol: {
      type: String,
      default: "",
    },
  },
};
</script>